export default "__VITE_ASSET__BFQaa$S4__"